import React from 'react';

const SVG = ({ style = {}, color = 'rgb(195, 135, 255)', width = '100%', viewBox = '0 0 100 100' }) => (
  <svg style={style} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <g>
      <circle cx="50" cy="50" r="46" fill="transparent" stroke={color} strokeWidth={8} />
      <rect x="27" y="29" width="46" height="8" fill={color} />
      <rect x="27" y="46" width="46" height="8" fill={color} />
      <rect x="27" y="63" width="46" height="8" fill={color} />
    </g>
  </svg>
);

export default SVG;
